import styles from './CartLink.scss';

import cx from 'classnames';
import { Entry } from 'contentful';
import React from 'react';

import { HasMaterialIcon, Link } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLink, IContentLinkProps } from 'src/components/ContentLink/ContentLink';
import { MaterialIcon } from 'src/components/MaterialIcon/MaterialIcon';
import { getCartItemLength } from 'src/utils/CartNavButtonUtils';
import { getField } from 'src/utils/EntryUtil';
import { Environment } from 'src/utils/Environment';

export interface ICartLink extends IContentLinkProps {
  entry?: Entry<Link>;
  hidden?: boolean;
  mobile?: boolean;
  children?: never;
}

export interface IUiState {
  cartTotal: number;
}

export class CartLink extends React.PureComponent<ICartLink, IUiState> {

  readonly state = { cartTotal: 0, isCloverMerchant: Environment.current.isExistingMerchant };

  componentDidMount() {
    this.setState({ cartTotal: getCartItemLength() });
  }

  render() {
    const { entry, hidden, mobile, className, ...props } = this.props;
    const materialIcon = getField(entry as Entry<HasMaterialIcon>, 'materialIcon');
    const title = getField(entry, 'title');
    if (this.state.isCloverMerchant) return null;
    return (
      <ContentLink
        tabIndex={hidden ? -1 : undefined}
        className={cx(styles.cartLink, className)}
        entry={entry}
        data-test="nav-item-cart"
        hideTitle
        {...props}
      >
        {materialIcon && (
          <MaterialIcon
            icon={materialIcon}
            data-cart-items-count={this.state.cartTotal}
            className={cx(styles.cartIcon, { [styles.cartIconHidePin]: this.state.cartTotal < 1 })}
          />
        )}
        {(!mobile || !materialIcon) && (title && <span className={styles.text}>{title}</span>)}
      </ContentLink>
    );
  }
}
